import { __assign } from "tslib";
import * as React from 'react';
import { I18nextProvider } from 'react-i18next';
import { i18nInit } from '../../i18n';
import { ManageInstalledAppsPage, } from '../manage-installed-apps-page';
import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { FontUpgrade } from 'wix-style-react';
import s from '../manage-installed-apps-page/manage-installed-apps-page.scss';
export { Origin } from '../manage-installed-apps-page';
export var ManageInstalledApps = function (props) {
    var locale = props.locale;
    return (React.createElement(ExperimentsProvider, { options: { scope: 'app-market-editor' } },
        React.createElement(I18nextProvider, { i18n: i18nInit(locale) },
            React.createElement(FontUpgrade, { className: s.fontUpgrade },
                React.createElement(ManageInstalledAppsPage, __assign({}, props))))));
};
//# sourceMappingURL=index.js.map